export default __webpack_public_path__ + "static/media/bulma.5910d441.svg";